import FileInput from '@/components/buddy/FileInput';

export default function CreatePostPage() {
  return (
    <div className="py-6">
      <h1 className="text-xl font-semibold mb-4">Guide MST Buddy</h1>
      <div className="py-4 max-w-[50dvw] mx-auto">
        <FileInput />
      </div>
    </div>
  );
}
